export default "__VITE_ASSET__Bc5WIXcM__"